import React, { Component } from 'react';
import AppSetting from './all_settings';

class ApplicationSetting extends Component {
  render() {
    return (
      <div> <AppSetting/> </div>
    );
  }
}

export default ApplicationSetting;
